var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
import MainHeader from '~/components/layouts/main/header';
import MainFooter from '~/components/layouts/main/Footer';
import ApplyContent from '~/components/index/Apply.vue';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.open = function () {
        this.$refs['ApplyContent'].dialogVisible = true;
    };
    default_1.prototype.initContact = function () {
        window.yzf && window.yzf.init({
            sign: '37ef9b97db2656c1761796bc48e1e433c0eefc9faa50555d3cc079cb779d1fb68d593765d9221ec465e4698a022b1c14f699988d',
            uid: '',
            data: {
                c1: '',
                c2: '',
                c3: '',
                c4: '',
                c5: ''
            },
            selector: '',
            callback: function (type, data) { }
        });
    };
    default_1 = __decorate([
        Component({
            components: {
                MainHeader: MainHeader,
                MainFooter: MainFooter,
                ApplyContent: ApplyContent,
            },
            middleware: "auth",
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./layouts/main.vue
// module id = uPRQ
// module chunks = 3